<template>
  <svg
    width="65"
    height="64"
    viewBox="0 0 65 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.5 45.8889H60.5V7H4.5V45.8889H32.5ZM32.5 45.8889V57M32.5 57H18.5M32.5 57H46.5M21.3 29.2222H43.7C43.2333 31.0741 40.34 34.7778 32.5 34.7778C24.66 34.7778 21.7667 31.0741 21.3 29.2222Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.5 22C19.5 23.6 20.8333 24 21.5 24C22.1667 24 23.5 23.6 23.5 22C23.5 20.4 22.1667 20 21.5 20C20.8333 20 19.5 20.4 19.5 22Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M41.5 22C41.5 23.6 42.8333 24 43.5 24C44.1667 24 45.5 23.6 45.5 22C45.5 20.4 44.1667 20 43.5 20C42.8333 20 41.5 20.4 41.5 22Z"
      stroke="white"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
